import PurchaseOrdersList from '@/features/proveedores/components/PurchaseOrdersList'

const PurchaseOrdersView = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      <div 
        className={`flex-1 flex flex-col transition-all duration-300`}
      >
        <main className="flex-1 overflow-y-auto p-6">
          <PurchaseOrdersList />
        </main>
      </div>
    </div>
  )
}

export default PurchaseOrdersView
